export const JxMapPaiZu = [{
    id: '249',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'questionCode',
    name: '问题类型',
    children: [
        { id: '250', parentId: '249', petitionVal: '', sortValue: '8', code: 'questionType_01', name: '违反政治纪律', children: [] },
        { id: '251', parentId: '249', petitionVal: '', sortValue: '7', code: 'questionType_02', name: '违反组织纪律', children: [] },
        { id: '252', parentId: '249', petitionVal: '', sortValue: '6', code: 'questionType_03', name: '违反廉洁纪律', children: [] },
        { id: '253', parentId: '249', petitionVal: '', sortValue: '5', code: 'questionType_04', name: '违反群众纪律', children: [] },
        { id: '254', parentId: '249', petitionVal: '', sortValue: '4', code: 'questionType_05', name: '违反工作纪律', children: [] },
        { id: '255', parentId: '249', petitionVal: '', sortValue: '3', code: 'questionType_06', name: '违反生活纪律', children: [] },
        { id: '256', parentId: '249', petitionVal: '', sortValue: '2', code: 'questionType_07', name: '违反中央八项规定精神', children: [] },
        { id: '257', parentId: '249', petitionVal: '', sortValue: '1', code: 'questionType_08', name: '其他', children: [] },

    ]
}]


// WEBPACK FOOTER //
// ./src/js/JxMapPaiZu.js